import { isNil } from "lodash";

// Drops everything past the second decimal instead of rounding, so a balance of 499.9999 is shown and
// treated as $499.99 rather than $500.00 (the producer can never transfer more than they actually have).
//
// The value is first snapped to 6 decimals to absorb IEEE-754 drift — without it 0.29 * 100 evaluates to
// 28.999999999999996 and would truncate to 0.28.
export default function truncateToCents(value) {
    if (isNil(value)) {
        return value;
    }

    return Math.trunc(Math.round(Number(value) * 1e6) / 1e4) / 100;
}
